"use client";

import { useEffect } from "react";
import { getLocaleDirection, type AppLocale } from "@/lib/utils/i18n";

type DirectionSyncProps = {
  locale: AppLocale;
};

const DirectionSync = ({ locale }: DirectionSyncProps) => {
  useEffect(() => {
    const html = document.documentElement;
    html.lang = locale;
    html.dir = getLocaleDirection(locale);
  }, [locale]);

  return null;
};

export default DirectionSync;
